import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";



class IsletmeTuruListeAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "IsletmeTuruListe";
    super(baseUrl);
  }


  getIsletmeTuruListeListe(yili: number, isletmeTuruKodu? : number){
    
    return this.get("", { params: { yili: yili, isletmeTuruKodu: isletmeTuruKodu} });
   
  }

}
export default new IsletmeTuruListeAPI();
class IsletmeTuruListeListeRequest {
  public Yili: number;
  public isletmeTuruKodu? : number;
  constructor(yili: number, isletmeTuruKodu? : number) {
    this.Yili = yili;
    this.isletmeTuruKodu = isletmeTuruKodu;
   
  }
}
export { IsletmeTuruListeListeRequest };